/**
 * Validator function for the email
 * @param {string} email
 * @returns true if the argument passes validation, false if fails
 */
export function isEmailValid (email) {
  return /\S+@\S+\.\S+/.test(email)
}
